import { useDispatch, useSelector } from "react-redux";
import {
    selectIsUserApprovedTerms,
    selectIsUserApprovedTermsFetched,
} from "app/pages/sales-intelligence/sub-modules/intent/store/signal/selectors/selectors";
import { useEffect, useState } from "react";
import {
    fetchIntentUserApprovalThunk,
    saveIntentUserApprovalThunk,
} from "app/pages/sales-intelligence/sub-modules/intent/store/signal/effects/effects";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

const useIntentUserApprovedAction = () => {
    const dispatch = useDispatch();
    const isUserApprovedTerms = useSelector(selectIsUserApprovedTerms);
    const isUserApprovedTermsFetched = useSelector(selectIsUserApprovedTermsFetched);
    const isImpersonatingUser = salesSettingsHelper.isImpersonating();
    const intentApproval = localStorage.getItem("si:intent-approval");
    const [isOpenApprovalModal, setIsOpenApprovalModal] = useState(false);

    useEffect(() => {
        if (!intentApproval) {
            void dispatch(fetchIntentUserApprovalThunk());
        }
    }, [intentApproval]);

    useEffect(() => {
        if (!isUserApprovedTermsFetched) {return;}

        if (isUserApprovedTerms) {
            localStorage.setItem("si:intent-approval", "true");
        }

        if (isUserApprovedTermsFetched && !isUserApprovedTerms && !isImpersonatingUser) {
            setIsOpenApprovalModal(!isUserApprovedTerms);
        }
    }, [isUserApprovedTerms, isUserApprovedTermsFetched, isImpersonatingUser]);

    const onClickUserApprovedTerms = () => {
        void dispatch(saveIntentUserApprovalThunk());
        localStorage.setItem("si:intent-approval", "true");
        setIsOpenApprovalModal(false);
    };

    return {
        isOpenApprovalModal,
        onClickUserApprovedTerms,
    };
};

export default useIntentUserApprovedAction;
